/* eslint-disable max-lines-per-function */
import { useCallback } from 'react';

import { Modal, ModalWidth } from '@dreryk/react-components';

import { statisticsTranslationKeys } from '../../translations';
import { GenerateMZ15FormLoader } from '../forms/GenerateMZ15Form.loader';
import { GenerateMZ15Form } from '../forms/GenerateMZ15Form';
import { GenerateMZ15StatisticsButton } from '../forms/buttons/GenerateMZ15StatisticsButton';

import { GenerateStatisticsModalButtons } from './GenerateStatisticsModalButtons';
import { handleStatisticsRefetch } from './GenerateStatisticsModal.utils';

type GenerateMZ15StatisticsModalProps = {
   readonly closeModal: VoidFunction;
};

export const GenerateMZ15StatisticsModal = (props: GenerateMZ15StatisticsModalProps): JSX.Element => {
   const handleOnSuccess = useCallback(() => {
      handleStatisticsRefetch(props.closeModal);
   }, [props.closeModal]);

   return (
      <Modal
         title={statisticsTranslationKeys.modal.title}
         onCloseRequest={props.closeModal}
         animateVisibility
         width={ModalWidth.NORMAL}
         testId={'generateMZ15StatisticsModal'}
         visible
      >
         <GenerateMZ15FormLoader>
            {({ healthcareProviderLocations }) => (
               <GenerateMZ15Form healthcareProviderLocations={healthcareProviderLocations}>
                  {({ handleSubmit, formState }) => (
                     <>
                        <GenerateMZ15StatisticsButton handleSubmit={handleSubmit} onSuccess={handleOnSuccess} />
                        <GenerateStatisticsModalButtons
                           handleClose={props.closeModal}
                           shouldConfirmExit={formState.isDirty}
                        />
                     </>
                  )}
               </GenerateMZ15Form>
            )}
         </GenerateMZ15FormLoader>
      </Modal>
   );
};
